module.exports = __webpack_public_path__ + "static/media/s_v10_21.3058cc03.mp3";